











import Form from '@/components/Forms/Form.vue';
import { View } from 'client-website-ts-library/plugins';
import { Component, Mixins } from 'vue-property-decorator';

@Component({
  components: {
    Form,
  },
})
export default class BuyerEnquiry extends Mixins(View) {

}
